import React, { useState } from "react";
import { Formik } from "formik";
import {
  forgotPasswordSubmit,
  forgotPassword,
} from "../../service/AuthService";
import { forgotPasswordValidation, emailValidation } from "../../validation";

import BtnPrimary from "../../components/Button";
import TextInput from "../../components/TextInput";
function ForgotPassowrd({ handleForgotPassword }) {
  const [loading, setLoading] = useState(false);
  const [errorMess, setErrorMess] = useState("");
  const [getEmail, setGetEmail] = useState(true);
  const [userEmail, setUserEmail] = useState(null);

  const emailValue = { email: "" };
  const forgotPasswordValues = { password: "", confirmPassword: "", code: "" };

  const handleEmail = ({ email }) => {
    setLoading(true);
    forgotPassword(email)
      .then(() => {
        setGetEmail(false);
        setUserEmail(email);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        setErrorMess(err.message);
      });
  };

  const handleForgotPasswordSubmit = ({ password, code }) => {
    setLoading(true);

    forgotPasswordSubmit(userEmail, code, password)
      .then(() => {
        setLoading(false);
        handleForgotPassword(false);
      })
      .catch((err) => {
        setLoading(false);
        setErrorMess(err.message);
      });
  };
  return (
    <>
      {getEmail ? (
        <Formik
          initialValues={emailValue}
          validationSchema={emailValidation}
          onSubmit={handleEmail}
        >
          {({
            handleChange,
            setFieldTouched,
            handleSubmit,
            email,
            touched,
            errors,
          }) => {
            const onInputChange = (name, e) => {
              handleChange(e);
              setFieldTouched(name, true, false);
            };
            return (
              <form onSubmit={handleSubmit}>
                <div className="error-message">{errorMess}</div>
                <TextInput
                  placeHolder="Email"
                  type="text"
                  value={email}
                  helperText={touched.email ? errors.email : ""}
                  onChange={(e) => onInputChange("email", e)}
                  id="email"
                  name="email"
                />
                <div
                  className="forgot-password"
                  onClick={() => handleForgotPassword(false)}
                >
                  Back to Login
                </div>
                <BtnPrimary type="submit" title="Get Code" loader={loading} />
              </form>
            );
          }}
        </Formik>
      ) : (
        <Formik
          initialValues={forgotPasswordValues}
          validationSchema={forgotPasswordValidation}
          onSubmit={handleForgotPasswordSubmit}
        >
          {({
            handleChange,
            setFieldTouched,
            handleSubmit,
            password,
            confirmPassword,
            code,
            touched,
            errors,
          }) => {
            const onInputChange = (name, e) => {
              handleChange(e);
              setFieldTouched(name, true, false);
            };
            return (
              <form onSubmit={handleSubmit}>
                <div className="error-message">{errorMess}</div>
                <TextInput
                  placeHolder="Code"
                  type="text"
                  value={code}
                  helperText={touched.code ? errors.code : ""}
                  onChange={(e) => onInputChange("code", e)}
                  id="code"
                  name="code"
                />
                <TextInput
                  placeHolder="Password"
                  type="password"
                  value={password}
                  helperText={touched.password ? errors.password : ""}
                  onChange={(e) => onInputChange("password", e)}
                  id="password"
                  name="password"
                />
                <TextInput
                  placeHolder="Confirm Password"
                  type="password"
                  value={confirmPassword}
                  helperText={
                    touched.confirmPassword ? errors.confirmPassword : ""
                  }
                  onChange={(e) => onInputChange("confirmPassword", e)}
                  id="confirmPassword"
                  name="confirmPassword"
                />
                <BtnPrimary
                  type="submit"
                  title="Reset Password"
                  loader={loading}
                />
              </form>
            );
          }}
        </Formik>
      )}
    </>
  );
}

export default ForgotPassowrd;
